module.exports = __webpack_public_path__ + "img/no_session_empty.5caf2d9d.png";